export default {
    FIRST_CHANNEL_ID: 0,
    FIRST_CHANNEL_INDEX: 0,
    DEFAULT_NAV_MENU: [
        {
            channel_id: 0,
            text: '推荐',
            is_fixed: true
        },
        {
            channel_id: 8,
            text: '新闻',
            is_fixed: true
        },
    ],
    FIXED_NAV_DIC: {
        0: {
            channel_id: 0,
            text: '推荐',
            is_fixed: true
        },
        8: {
            channel_id: 8,
            text: '新闻',
            is_fixed: true
        }
    },
    STORE_NAV_KEY: 'store_nav_list',
    STORE_TIP_TIME: 'store_tip_time'
}


// WEBPACK FOOTER //
// ./src/_store/const.js